export enum EFileType {
  PDF = "pdf",
  DOCX = "docx",
  PNG = "png",
  JPEG = "jpeg",
  JPG = "jpg",
}
